import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

const InventoryCustomer = () => {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    phoneNumber: '',
    role: '',
    permissions: [],
    status: '',
    country: '',
    address: ''
  });

  const [error, setError] = useState('');
  const [savedData, setSavedData] = useState(null);
  const [viewMode, setViewMode] = useState("customer");

  useEffect(() => {
    // Retrieve saved data from localStorage on load
    const storedData = JSON.parse(localStorage.getItem('subUserData'));
    if (storedData) {
      setSavedData(storedData);
    }
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === 'checkbox') {
      setFormData({
        ...formData,
        permissions: checked
          ? [...formData.permissions, value]
          : formData.permissions.filter((permission) => permission !== value),
      });
    } else if (type === 'select-multiple') {
      const selectedPermissions = Array.from(e.target.selectedOptions, option => option.value);
      setFormData({ ...formData, permissions: selectedPermissions });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validation checks (example)
    if (!formData.username || !formData.email || !formData.phoneNumber || !formData.role || !formData.status) {
      setError('All required fields must be filled out');
      return;
    }

    // Save data to localStorage
    localStorage.setItem('subUserData', JSON.stringify(formData));

    // toast.error when saved
    toast.error('User data has been saved successfully!');

    // Clear form after submission
    setFormData({
      username: '',
      email: '',
      phoneNumber: '',
      role: '',
      permissions: [],
      status: '',
      country: '',
      address: ''
    });
  };

  return (
    <div className="bg-white p-4">
      <h2 className="text-2xl font-bold mb-4">Sub-User Registration</h2>

      {error && <div className="text-red-500 mb-4">{error}</div>}
      
      {viewMode === "customer" && (
        <form onSubmit={handleSubmit}>
          <div className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex flex-col">
                <label className="text-sm font-semibold text-gray-700 mb-2">User Name *</label>
                <input
                  type="text"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  className="w-full mt-2 p-2 border border-gray-300 rounded"
                  required
                />
              </div>
              <div className="flex flex-col">
                <label className="text-sm font-semibold text-gray-700 mb-2">Email *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full mt-2 p-2 border border-gray-300 rounded"
                  required
                />
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex flex-col">
                <label className="text-sm font-semibold text-gray-700 mb-2">Phone Number *</label>
                <input
                  type="tel"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  className="w-full mt-2 p-2 border border-gray-300 rounded"
                  required
                />
              </div>

              <div className="flex flex-col">
                <label className="text-sm font-semibold text-gray-700 mb-2">Role *</label>
                <select
                  name="role"
                  value={formData.role}
                  onChange={handleChange}
                  className="w-full mt-2 p-2 border border-gray-300 rounded"
                  required
                >
                  <option value="">Select Role</option>
                  <option value="user">User</option>
                  <option value="employee">Employee</option>
                </select>
              </div>
            </div>

            <div className="flex flex-col">
              <label className="text-sm font-semibold text-gray-700 mb-2">Permissions *</label>
              <select
                name="permissions"
                value={formData.permissions}
                onChange={handleChange}
                multiple
                className="w-full mt-2 p-2 border border-gray-300 rounded"
              >
                {[
                  'Dashboard',
                  'eSim Store',
                  'Transactions',
                  'Wallet Top-up',
                  'News and Updates',
                  'Inventory Management',
                  'Purchase History',
                  'API Box',
                  'Help and Support',
                  'Create Ticket'
                ].map((permission) => (
                  <option key={permission} value={permission}>
                    {permission}
                  </option>
                ))}
              </select>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex flex-col">
                <label className="text-sm font-semibold text-gray-700 mb-2">Status *</label>
                <select
                  name="status"
                  value={formData.status}
                  onChange={handleChange}
                  className="w-full mt-2 p-2 border border-gray-300 rounded"
                  required
                >
                  <option value="">Select Status</option>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>

              <div className="flex flex-col">
                <label className="text-sm font-semibold text-gray-700 mb-2">Country/Region</label>
                <input
                  type="text"
                  name="country"
                  value={formData.country}
                  onChange={handleChange}
                  className="w-full mt-2 p-2 border border-gray-300 rounded"
                />
              </div>
            </div>
            <div className='flex gap-4'>
              <button
                type="submit"
                className="bg-teal-500 rounded-full p-4 text-white shadow-md hover:bg-[#1cbebe] transition duration-200"
                >
                Save User Data
              </button>
              <button 
                onClick={() => setViewMode("showData")} 
                className="bg-[#117575] rounded-full p-4 text-white shadow-md hover:bg-[#1cbebe] transition duration-200 "
                >
                Saved Data
              </button>
            </div>
          </div>
        </form>
      )}

{viewMode === "showData" && savedData && (
  <div className="mt-6 p-4   rounded">
    <table className="w-full  table-auto">
      <thead className="bg-gray-200">
        <tr>
          <th className="border border-gray-300 p-2 text-left font-semibold">Username</th>
          <th className="border border-gray-300 p-2 text-left font-semibold">Email</th>
          <th className="border border-gray-300 p-2 text-left font-semibold">Phone Number</th>
          <th className="border border-gray-300 p-2 text-left font-semibold">Role</th>
          <th className="border border-gray-300 p-2 text-left font-semibold">Permissions</th>
          <th className="border border-gray-300 p-2 text-left font-semibold">Status</th>
          <th className="border border-gray-300 p-2 text-left font-semibold">Country/Region</th>
          <th className="border border-gray-300 p-2 text-left font-semibold">Address</th>
        </tr>
      </thead>
      <tbody>
        <tr className="border-t border-gray-200">
          <td className="border border-gray-300 p-2">{savedData.username}</td>
          <td className="border border-gray-300 p-2">{savedData.email}</td>
          <td className="border border-gray-300 p-2">{savedData.phoneNumber}</td>
          <td className="border border-gray-300 p-2">{savedData.role}</td>
          <td className="border border-gray-300 p-2">
            {savedData.permissions.join(', ')}
          </td>
          <td className="border border-gray-300 p-2">{savedData.status}</td>
          <td className="border border-gray-300 p-2">{savedData.country}</td>
          <td className="border border-gray-300 p-2">{savedData.address}</td>
        </tr>
      </tbody>
    </table>
  </div>
)}

    </div>
  );
};

export default InventoryCustomer;
